// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_GZcW0","status":"index_status_2UgfJ","footer":"index_footer_TM-7h"};